const IMAGE_SIZES = {
  ORIGINAL: 'original',
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
};

const MEDIA_DOMAIN_BUCKET_MAP = {
  'https://quality-data.operabase.net': 'dqa',
  'https://data.operabase.com': 'dprod',
  'https://quality-static.operabase.net': 'sqa',
  'https://static.truelinked.com': 'sprod',
};

const BUCKET_MEDIA_DOMAIN_MAP = Object.entries(MEDIA_DOMAIN_BUCKET_MAP).reduce((acc, [key, value]) => {
  acc[value] = key;
  return acc;
}, {});

export const condenseImageObject = imgObj => {
  const { original, blurHash } = imgObj || {};

  if (!original) {
    return imgObj;
  }

  let origin;
  let pathname;

  try {
    const urlObj = new URL(original);
    origin = urlObj.origin;
    pathname = urlObj.pathname;
  } catch (error) {
    return imgObj;
  }

  const bucket = MEDIA_DOMAIN_BUCKET_MAP[origin];

  return {
    blurHash,
    pathname: `${bucket}${pathname}`,
  };
};

export const expandImageObject = (imgObj, options = {}) => {
  const { size } = options;
  const { blurHash, pathname } = imgObj || {};

  if (!pathname) {
    return imgObj;
  }

  const [bucket, ...rest] = (pathname || '').split('/');

  const origin = BUCKET_MEDIA_DOMAIN_MAP[bucket];

  const original = `${origin}/${rest.join('/')}`;
  let large;
  let medium;
  let small;

  if (!size || size === IMAGE_SIZES.LARGE) {
    large = original.replace(`-${IMAGE_SIZES.ORIGINAL}`, `-${IMAGE_SIZES.LARGE}`);
  }

  if (!size || size === IMAGE_SIZES.MEDIUM) {
    medium = original.replace(`-${IMAGE_SIZES.ORIGINAL}`, `-${IMAGE_SIZES.MEDIUM}`);
  }

  if (!size || size === IMAGE_SIZES.SMALL) {
    small = original.replace(`-${IMAGE_SIZES.ORIGINAL}`, `-${IMAGE_SIZES.SMALL}`);
  }

  return {
    blurHash,
    ...(!size && { original }),
    ...(large && { large }),
    ...(medium && { medium }),
    ...(small && { small }),
  };
};
